import {PermissionActionType} from './actionTypes';

const setPermissions = (dispatch, data) => {
  dispatch({type: PermissionActionType.SET_PERMISSIONS, data});
};

export {setPermissions};
